import { render, staticRenderFns } from "./OrderInfoDetail.vue?vue&type=template&id=7179de2c&scoped=true&"
import script from "./OrderInfoDetail.vue?vue&type=script&lang=js&"
export * from "./OrderInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoDetail.vue?vue&type=style&index=0&id=7179de2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7179de2c",
  null
  
)

export default component.exports